import cfg from './environment';
import storage from './start-account-storage';

export function init(window) {
  try {
    window.onerror = function () {
      // prevent error from propagating so any error outside of this try/catch
      // does not prevent logins from Okta orgs page
      return true;
    };

    var env = cfg.getOktaEnvironment(window.location.host);
    storage.startAccountStorage(env.trustedRootDomains, window);

    if (window.parent) {
      window.parent.postMessage({messageType: 'iframe_loaded'}, '*');
    }
  } catch (e) {
    // any error within this try/catch should not prevent logins from Okta orgs page
  }
}



// WEBPACK FOOTER //
// ./lib/init-iframe.js